/* eslint-disable prefer-destructuring */
import { Controller } from "@hotwired/stimulus";
import noUiSlider from 'nouislider';
import { Tracking } from '../shared/helpers';

export default class extends Controller {
  static targets = ['minVisual', 'minValue', 'maxVisual', 'maxValue'];

  connect() {
    const elementId = this.data.get('elementId');
    const filterMinValue = parseFloat(this.data.get('filterMinValue'));
    const filterMaxValue = parseFloat(this.data.get('filterMaxValue'));
    const minValue = parseFloat(this.data.get('minValue'));
    const maxValue = parseFloat(this.data.get('maxValue'));
    const rangeSlider = this.element.querySelector(`#${elementId}`);

    if (!this.element.querySelector('.noUi-base')) {
      noUiSlider.create(rangeSlider, {
        start: [minValue, maxValue],
        connect: true,
        step: 1,
        range: {
          min: filterMinValue,
          max: filterMaxValue
        }
      });

      rangeSlider.noUiSlider.on('update', values => {
        this.onUpdate(values);
      });

      rangeSlider.noUiSlider.on('change', () => {
        this.onChange();
      });
    }
  }

  onUpdate(values) {
    this.minVisualTarget.textContent = this.format(values[0]);
    this.minValueTarget.value = values[0];

    this.maxVisualTarget.textContent = this.format(values[1]);
    this.maxValueTarget.value = values[1];
  }

  onChange() {
    const autoFormSubmit = this.minValueTarget.form.parentNode;
    const autoFormSubmitController = this.application.getControllerForElementAndIdentifier(
      autoFormSubmit,
      'auto-form-submit'
    );
    this.handleTracking(this.type);
    autoFormSubmitController.submit();
  }

  handleTracking(type) {
    Tracking.action('MyGarage', 'OfferOverview Filtering', type);
  }

  format(value) {
    const floatValue = parseFloat(value);

    if (this.type === 'price') return this.formatPrice(floatValue);
    return this.formatDistance(floatValue);
  }

  formatPrice(value) {
    if (this.locale === 'da' || this.locale === 'sv') {
      return `${value.toLocaleString('da-DK', { minimumFractionDigits: 2 })} kr`;
    } else if (this.locale === 'en') {
      return `£${value.toLocaleString('en-GB', { minimumFractionDigits: 2 })}`;
    }
    return `${value.toLocaleString('de-DE', { minimumFractionDigits: 2 })} €`;
  }

  formatDistance(value) {
    if (this.locale === 'en') {
      return `${value.toLocaleString('en-GB', { minimumFractionDigits: 1 })} miles`;
    } else if (this.locale === 'sv') {
      const valueInMil = value / 10;
      return `${valueInMil.toLocaleString('sv-SE', { minimumFractionDigits: 1 })} mil`;
    }
    return `${value.toLocaleString('da-DA', { minimumFractionDigits: 1 })} km`;
  }

  get type() {
    if (this.data.get('elementId') === 'price_range') {
      return 'price';
    }
    return 'distance';
  }

  get locale() {
    return document.querySelector('html').getAttribute('lang');
  }

  roundUp(x) {
    return Math.ceil(x / 5) * 5.0;
  }

  roundDown(x) {
    return Math.floor(x / 5) * 5.0;
  }
}
